import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, IconButton, Badge, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowDropDown, Menu as MenuIcon, ShoppingCart } from '@mui/icons-material'; // Importing icons
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import LoginRegisterModal from './LoginRegisterModal';
import { trackContact } from '../utils/supabaseEdgeApi';

const Navbar = ({ setCategory, isMVP }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [contactAnchorEl, setContactAnchorEl] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false); // State to manage Drawer visibility
    const envType = process.env.REACT_APP_ENVIRONMENT_SETUP === 'local' || false
    const categories = [
        'All',
        'Homa',
        'Bali',
        'Shanti',
        'Parayana',
        'Pooja',
        'Vrata',
        'Special Occasion',
        'Abhisheka'
    ];
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const { cartCount = 0 } = useCart();
    const [authOpen, setAuthOpen] = useState(false);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (category) => {
        setAnchorEl(null);
        if (category) {
            setCategory(category);
            setSelectedCategory(category);
            navigate('/')
        }
    };

    const handleContactOpen = (event) => {
        setContactAnchorEl(event.currentTarget);
    };

    const handleContactClose = () => {
        setContactAnchorEl(null);
    };

    // Handle drawer toggle
    const toggleDrawer = (open) => {
        setDrawerOpen(open);
    };

    // Drawer content for mobile view
    const drawerContent = (
        <List>
            <ListItem button component={Link} to="/" onClick={() => toggleDrawer(false)}>
                <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={Link} to="/about" onClick={() => toggleDrawer(false)}>
                <ListItemText primary="About" />
            </ListItem>
            {!isMVP && (
                <ListItem button component={Link} to="/cart" onClick={() => toggleDrawer(false)}>
                    <ListItemText primary={`Cart${cartCount ? ` (${cartCount})` : ''}`} />
                </ListItem>
            )}
            <ListItem button color="inherit" onClick={handleMenuOpen}>
                <ListItemText primary="Poojas" />
            </ListItem>
            <ListItem button color="inherit" onClick={handleContactOpen}>
                <ListItemText primary="Contact Us" />
            </ListItem>
            {envType && (
              <ListItem button component={Link} to="/dashboard" onClick={() => toggleDrawer(false)}>
                  <ListItemText primary="Dashboard" />
              </ListItem>
            )}
            {!isMVP && user ? (
                <>
                    <ListItem button component={Link} to="/my-bookings" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="My Bookings" />
                    </ListItem>
                    <ListItem button component={Link} to="/profile" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="Profile" />
                    </ListItem>
                    <ListItem button onClick={() => { logout(); toggleDrawer(false); }}>
                        <ListItemText primary="Logout" />
                    </ListItem>
                </>
            ) : !isMVP ? (
                <ListItem button onClick={() => { setAuthOpen(true); toggleDrawer(false); }}>
                    <ListItemText primary="Login / Register" />
                </ListItem>
            ) : null}
        </List>
    );

    return (
        <>
            <AppBar position="static" sx={{ backgroundColor: '#a52a2a' }}>
                <Toolbar>
                    <Typography
                        variant="h6"
                        component={Link}
                        to="/"
                        sx={{
                            flexGrow: 1,
                            fontWeight: 'bold',
                            textDecoration: 'none',
                            color: 'inherit',
                            cursor: 'pointer',
                        }}
                    >
                        Vedamarga
                    </Typography>
                    {/* Desktop view buttons */}
                    <Button
                        component={Link}
                        to="/"
                        color="inherit"
                        sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                    >
                        Home
                    </Button>
                    <Button
                        component={Link}
                        to="/astrology"
                        color="inherit"
                        sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                    >
                        Astrology
                    </Button>
                    {envType && (
                        <Button
                            component={Link}
                            to="/dashboard"
                            color="inherit"
                            sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                        >
                            Dashboard
                        </Button>
                    )}
                    <Button
                        component={Link}
                        to="/about"
                        color="inherit"
                        sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                    >
                        About
                    </Button>
                    {!isMVP && (
                        <Button
                            component={Link}
                            to="/cart"
                            color="inherit"
                            sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                        >
                            <Badge badgeContent={cartCount} color="error">
                                <ShoppingCart sx={{ mr: 1 }} /> Cart
                            </Badge>
                        </Button>
                    )}
                    <Button
                        color="inherit"
                        aria-controls="poojas-menu"
                        aria-haspopup="true"
                        onClick={handleMenuOpen}
                        sx={{
                            textTransform: 'none',
                            display: { xs: 'none', sm: 'inline-flex' },
                            position: 'relative',
                        }}
                    >
                        Poojas
                        <ArrowDropDown sx={{ marginLeft: 1 }} />
                        {selectedCategory && selectedCategory !== 'All' && (
                            <Badge
                                badgeContent={1}
                                color="error"
                                sx={{
                                    position: 'absolute',
                                    top: -5,
                                    right: -10,
                                    fontSize: '12px',
                                }}
                            />
                        )}
                    </Button>
                    <Button
                        aria-controls="contact-menu"
                        aria-haspopup="true"
                        onClick={handleContactOpen}
                        color="inherit"
                        sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                    >
                        Contact Us
                    </Button>
                    {!isMVP && user ? (
                        <>
                            <Button
                                component={Link}
                                to="/my-bookings"
                                color="inherit"
                                sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                            >
                                My Bookings
                            </Button>
                            <Button
                                component={Link}
                                to="/profile"
                                color="inherit"
                                sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                            >
                                Profile
                            </Button>
                            <Button
                                color="inherit"
                                onClick={logout}
                                sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                            >
                                Logout
                            </Button>
                        </>
                    ) : !isMVP ? (
                        <Button
                            color="inherit"
                            onClick={() => setAuthOpen(true)}
                            sx={{ textTransform: 'none', display: { xs: 'none', sm: 'inline-flex' } }}
                        >
                            Login / Register
                        </Button>
                    ) : null}
                    <Menu
                        id="poojas-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => handleMenuClose(null)}
                    >
                        {categories.map((category, index) => (
                            <MenuItem key={index} onClick={() => handleMenuClose(category)}>
                                {category}
                            </MenuItem>
                        ))}
                    </Menu>
                    <Menu
                        id="contact-menu"
                        anchorEl={contactAnchorEl}
                        open={Boolean(contactAnchorEl)}
                        onClose={handleContactClose}
                    >
                        <MenuItem onClick={handleContactClose}>
                            <a href="tel:+919986144114" onClick={() => trackContact('call')} style={{ textDecoration: 'none', color: 'inherit' }}>
                                📞 Call: +919986144114
                            </a>
                        </MenuItem>
                        <MenuItem onClick={handleContactClose}>
                            <a href="mailto:vedamarga1@gmail.com" onClick={() => trackContact('email')} style={{ textDecoration: 'none', color: 'inherit' }}>
                                📧 Email: vedamarga1@gmail.com
                            </a>
                        </MenuItem>
                    </Menu>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        sx={{ display: { xs: 'block', sm: 'none' } }}
                        onClick={() => toggleDrawer(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Drawer anchor="right" open={drawerOpen} onClose={() => toggleDrawer(false)}>
                {drawerContent}
            </Drawer>

            <LoginRegisterModal
                open={authOpen}
                onClose={() => setAuthOpen(false)}
                onSuccess={() => setAuthOpen(false)}
            />
        </>
    );
};

export default Navbar;
